import styled from 'styled-components';

const InlinePlayerContainer = styled.div`
  .tools-roi-section--container {
    padding: 0;
  }

  .w-bottom-bar-lower {
    display: ${({ isFullScreen, isPlaying }) =>
      !isFullScreen && !isPlaying ? 'none !important' : 'block'};
  }
`;

export default InlinePlayerContainer;
